import type { IntakeDoc } from '../data/state.js';

export interface AttachmentProcessingState {
  active: IntakeDoc[];
  failed: IntakeDoc[];
  progress: number | null;
}

/** Aggregate document extraction into the one header-level state shown to users. */
export function attachmentProcessingState(filesByKind: Record<string, IntakeDoc[]>): AttachmentProcessingState {
  const docs = Object.values(filesByKind).flat();
  const active = docs.filter((doc) => doc.extractionStatus === 'pending' || doc.extractionStatus === 'reading');
  const failed = docs.filter((doc) => doc.extractionStatus === 'failed');
  const progress = active.length === 0 ? null : active.some((doc) => doc.extractionStatus === 'reading') ? 65 : 25;
  return { active, failed, progress };
}

export function settledAttachments(docs: IntakeDoc[]): IntakeDoc[] {
  return docs.filter(
    (doc) => doc.extractionStatus === undefined || doc.extractionStatus === 'done' || doc.extractionStatus === 'failed',
  );
}

/** A completed quotation upload can still leave the reviewer with no quote to compare. */
export function quotationNeedsReview(doc: IntakeDoc): boolean {
  return (
    (doc.kind === 'quotation' || doc.kind === 'comparison-sheet') &&
    doc.extractionStatus === 'done' &&
    doc.extractionResult?.quotationsCreated === 0
  );
}
